export const stripTrailingSlashes = (url?: string): string | undefined => {
    if (!url) {
        return url;
    }

    return url.replace(/\/+$/, '');
};

export const joinApiUrl = (base: string | undefined, path: string): string => {
    const normalizedBase = stripTrailingSlashes(base || '') || '';
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    return `${normalizedBase}${normalizedPath}`;
};
